export enum Region {
  HK = "hk",
  SG = "sg",
  AU = "au",
}
